import { useState, useCallback } from 'react';
import api from '../../../services/api';

export const useQRCode = (opticianId) => {
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchQRCode = useCallback(async () => {
    if (!opticianId) return;
    
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const { data } = await api.get(`/qr-codes/optician/${opticianId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setQrCode(data);
    } catch (err) {
      console.error('Erreur QR code:', err);
    } finally {
      setLoading(false);
    }
  }, [opticianId]);

  const downloadQRCode = useCallback(async () => {
    if (!qrCode?.url_code) return;

    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/qr-codes/${qrCode.url_code}/download`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });

      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `qr-code-fideliz.png`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('Erreur téléchargement QR:', err);
    }
  }, [qrCode]);

  return { qrCode, loading, fetchQRCode, downloadQRCode };
};

